export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "SOCIALS",
    accessor: "name",
  },
  {
    Header: "ACTIVITY(%)",
    accessor: "progress",
  },
  {
    Header: "FAKE",
    accessor: "quantity",
  },
  {
    Header: "TRENDING TOPICS",
    accessor: "date",
  },
];

export const twitterColumnsDataCheck = [
  {
    Header: "Topic",
    accessor: "name",
  },
  {
    Header: "Posts",
    accessor: "number_of_posts",
  },
  {
    Header: "%Fake",
    accessor: "percentage_fake",
  },
  {
    Header: "Possible Spreaders",
    accessor: "spreaders",
  },
  {
    Header: "Possible Victims",
    accessor: "victims",
  },
  {
    Header: "Ideology",
    accessor: "ideology",
  },
];
export const twitterUsersColumnsDataCheck = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Retweets",
    accessor: "retweets",
  },
  {
    Header: "Fake(%)",
    accessor: "fake_news",
  },
  {
    Header: "Comments",
    accessor: "comments",
  },
  {
    Header: "Views",
    accessor: "views_posted",
  },
];

export const twitterAccountColumnsDataCheck = [
  {
    Header: "Post",
    accessor: "post",
  },
  {
    Header: "Activity",
    accessor: "activity",
  },
  {
    Header: "Community-ID",
    accessor: "activity_id",
  },
];

export const instagramColumnsDataCheck = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Posts",
    accessor: "number_of_posts",
  },
  {
    Header: "%Fake",
    accessor: "percentage_fake",
  },
  {
    Header: "Spreaders",
    accessor: "spreaders",
  },
  {
    Header: "Victims",
    accessor: "victims",
  },
  {
    Header: "Ideology",
    accessor: "ideology",
  },
];
export const redditColumnsDataCheck = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Posts",
    accessor: "number_of_posts",
  },
  {
    Header: "%Fake",
    accessor: "percentage_fake",
  },
  {
    Header: "Spreaders",
    accessor: "spreaders",
  },
  {
    Header: "Victims",
    accessor: "victims",
  },
  {
    Header: "Ideology",
    accessor: "ideology",
  },
];

export const columnsDataColumns = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];
